import React from "react"

export const LogoSchema = () => {
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    url: "https://pass-tickets.com",
                    logo: {
                        "@type": "ImageObject",
                        url: "https://cdn.pass-tickets.com/frontend/logo-optimized.png",
                        width: 112,
                        height: 112,
                        caption: "PassTickets",
                    },
                }),
            }}
        />
    )
}

export const WebsiteSchema = () => {
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    url: "https://pass-tickets.com",
                    name: "PassTickets",
                    alternateName: "PassTickets",
                    potentialAction: {
                        "@type": "SearchAction",
                        target: "https://pass-tickets.com/search?q={search_term_string}",
                        "query-input": "required name=search_term_string",
                    },
                }),
            }}
        />
    )
}

export const OrganizationSchema = () => {
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    name: "PassTickets",
                    alternateName: "PassTickets",
                    description:
                        "A complete platform for selling tickets and creating events in any field imaginable",
                    url: "https://pass-tickets.com",
                    logo: {
                        "@type": "ImageObject",
                        url: "https://cdn.pass-tickets.com/frontend/hero.png",
                        width: 800,
                        height: 600,
                        caption: "PassTickets",
                    },
                    image: "https://cdn.pass-tickets.com/frontend/hero.png",
                    sameAs: [
                        "https://twitter.com/PassTickets",
                        "https://www.facebook.com/PassTickets",
                        "https://www.instagram.com/PassTickets",
                    ],
                    address: {
                        "@type": "PostalAddress",
                        addressCountry: "SA",
                    },
                }),
            }}
        />
    )
}

export default {
    LogoSchema,
    WebsiteSchema,
    OrganizationSchema,
}
